import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
// import { AboutComponent } from './about/about.component'
// import { CareerCreationCourseLandingComponent } from './career-creation-course-landing/career-creation-course-landing.component'
import { HomeScreenComponent } from './home/home.component'
// import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component'
// import { PublicRoutes } from './public-route-names'
// import { SelfBrandingCourseLandingComponent } from './self-branding-course-landing/self-branding-course-landing/self-branding-course-landing.component'
// import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component'

const routes: Routes = [
  {
    path: '',
    component: HomeScreenComponent
  },
  // {
  //   path: PublicRoutes.CCCPage,
  //   component: CareerCreationCourseLandingComponent
  // },
  // {
  //   path: PublicRoutes.TermsOfUsePage,
  //   component: TermsOfUseComponent
  // },
  // {
  //   path: PublicRoutes.PrivacyPolicyPage,
  //   component: PrivacyPolicyComponent
  // },
  // {
  //   path: PublicRoutes.AboutPage,
  //   component: AboutComponent
  // },
  // {
  //   path: PublicRoutes.SelfBrandingCoursePage,
  //   component: SelfBrandingCourseLandingComponent
  // }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PublicRoutingModule {}
